__turbopack_context__.v({
  "awardIcon": "AwardItem-module-scss-module__WP5b2W__awardIcon",
  "awardItem": "AwardItem-module-scss-module__WP5b2W__awardItem",
  "date": "AwardItem-module-scss-module__WP5b2W__date",
  "description": "AwardItem-module-scss-module__WP5b2W__description",
  "details": "AwardItem-module-scss-module__WP5b2W__details",
  "title": "AwardItem-module-scss-module__WP5b2W__title",
});
